
export interface CatalogoItem {
    id: number
    nombre: string
}

export interface ConfigInicialForm {
    id: number | null
    identificador: string
    numero_pantalla: number | null
    organizacion_id: number | string
    eds_id: number | string
    equipo_id: number | string
    estado_id: number
    detalle_ids: number[]
    permitir_efectivo: boolean
    inactividad_segundos: number
    monto_minimo_programacion: number
    tiempo_espera_pago: number
    datafono_id: number | null
}

export interface ConfigInicialRow extends ConfigInicialForm {
    id: number
}

export interface ConfigInicialPayload {
    identificador: string
    numero_pantalla: number
    equipo_id: number
    estado_id: number
    detalle_ids: number[]
    permitir_efectivo: boolean
    inactividad_segundos: number
    monto_minimo_programacion: number
    tiempo_espera_pago: number
    datafono_id: number | null
}

export interface ConfiguracionInicialContextType {
    rows: ConfigInicialRow[]
    loadingTable: boolean
    query: string
    setQuery: (value: string) => void
    filteredRows: ConfigInicialRow[]

    datafonos: CatalogoItem[]
    surtidoresDetalles: CatalogoItem[]

    organizaciones: any[]
    edsOptions: any[]
    equipos: CatalogoItem[]
    loadingEds: boolean
    loadingEquipos: boolean
    onChangeOrganizacion: (orgId: any) => void
    onChangeEds: (edsId: any) => void

    modalOpen: boolean
    step: number
    form: ConfigInicialForm
    errors: Record<string, string>
    saving: boolean

    openView: (row: ConfigInicialRow) => void 
    openNew: () => void
    openEdit: (row: ConfigInicialRow) => void
    closeModal: () => void
    setField: (key: keyof ConfigInicialForm, value: any) => void
    next: () => void
    back: () => void
    save: () => Promise<{ success: boolean; message?: string }>

    toggleDetalle: (id: number) => void
    isDetalleSeleccionado: (id: number) => boolean

    fetchListado: (edsId: string | number | null) => void
    toggleEstadoConfiguracion: (record: ConfigInicialForm) => Promise<{ success: boolean; message?: string }>

    loadingDetalle: boolean
    readOnly: boolean
}

export const ESTADOS_CONFIG = {
    ACTIVO: 1,
    INACTIVO: 2
}